import React, { useEffect, useState, useMemo, useRef } from 'react';
import DOMPurify from 'dompurify';
import IframeFunctional from './IframeFunctional';
import {
  getTemplatesByType,
  getAgreementTypes,
  getPromotionsWithoutAgreement,
  requestTemplatePresave,
  getEmailsTemplates,
  getIsFieldShowingInFile,
  initIaTemplate,
} from './details_expedient/expedient_details_logic';
import { Button, Form } from 'react-bootstrap';
import { selectStylesDefault, fieldsValidation } from './my_expedients/expedients_list_logic';
import Select from 'react-select';
import Cookies from 'js-cookie';
import { renderErrorsList, renderClassesToErrors } from '../edit_profile/edit_profile_logic';
import { NotificationManager } from 'react-notifications';
import ModalComponentPortal from '../helper_components/modals/modalComponentPortal/ModalComponentPortal';
import AgreementWithoutPromotionModal from './details_expedient/modals/AgreementWithoutPromotionModal';
import { templatesTypesToAskIfIsAPublishBulletin } from '../../services/dataFormatting/templatesTypesToAskIfIsAPublishBulletin';
import { BulletinFields } from './details_expedient/components/BulletinFields/BulletinFields';
import RichTextEditor from '../richTextEditor/RichTextEditor';
import {
  getLetterheadBackdrop,
  buildLetterheadContentStyle,
  buildThumbnailStyle,
} from '../../services/tinymce/letterheadBackdrop';
import useImagesWithCorsErrorState from '../richTextEditor/hooks/imagesWithCorsErrorState/useImagesWithCorsErrorState';
import _, { set } from 'lodash';
import { useLoaderContext } from '../layout/shared/loader_context';
import DatePicker, { registerLocale } from 'react-datepicker';
import es from 'date-fns/locale/es';
import CustomInputDate from './details_expedient/components/CustomInputDate/CustomInputDate';
import {
  isWeekday,
  holidayDates,
} from './details_expedient/components/CustomInputDate/CustomDateRules';
import { secondCustomHeaderDatePicker } from './details_expedient/expedient_details_logic';
import moment from 'moment';
import { setDate } from 'date-fns';

registerLocale('es', es);

const stylesDiv = {
  paddingLeft: '10px',
  paddingRight: '15px',
  paddingTop: '15px',
  paddingBottom: '15px',
  fontSize: '5px',
  cursor: 'pointer',
};

const stylesDiv2 = {
  width: '160px',
  height: '240px',
  fontSize: '5px',
  backgroundColor: 'white',
  pointerEvents: 'none',
};

const stylesDiv3 = {
  paddingBottom: '20px',
  cursor: 'pointer',
};

const stylesFormatted = {
  ...selectStylesDefault,
  menu: (provided, state) => ({
    ...provided,
    zIndex: 100,
  }),
};

export const selectStylesError = {
  control: (provided, state) => {
    return {
      ...provided,
      border: '1px solid red',
    };
  },
};

const PreviewTemplates = ({
  type,
  expedientNumber,
  setReloadDataTemplates,
  reloadDataTemplates,
  setShowModalTemplates,
  expedientId = '',
  judgesAndSecretaries = {},
  dataExpedient,
}) => {
  const { userId_03 } = Cookies.get();
  const [templates, setTemplates] = useState([]);
  const [showModalTiny, setShowModalTiny] = useState(false);
  const [showModalConfirm, setShowModalConfirm] = useState(false);
  const [templateTiny, setTemplateTiny] = useState({
    type: type,
    alias: '',
    headings: [],
    user_id: userId_03,
    judgeName: '',
    agreementsSecretary: '',
    sentenceDate: '',
    publication_date: '',
    isAPublic: false,
    ifexcerpt: false,
  });

  const [agreementTypes, setAgreementTypes] = useState([]);
  const [promotions, setPromotions] = useState([]);
  const [errors, setErrors] = useState({});
  const [emailsOptions, setEmailsOptions] = useState([]);
  const [selectedPromotions, setSelectedPromotions] = useState([]);
  const [selectedAlias, setSelectedAlias] = useState('');
  const [selectedAgreementTypes, setSelectedAgreementTypes] = useState([]);
  const shouldAskIfIsAPublishBulletin = useMemo(
    () => templatesTypesToAskIfIsAPublishBulletin.includes(type),
    [type]
  );
  const [holiday, setHoliday] = useState([]);
  const imagesWithCorsErrorState = useImagesWithCorsErrorState();
  const loader = useLoaderContext();
  const firstInputDatePicker = useRef(null);
  const [dateIsAccepted, setDateIsAccepted] = useState(false);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const hasAttemptedToOpenIAModal = useRef(false);
  const [iaTemplateId, setIaTemplateId] = useState(null);
  const [isTemplateByIA, setIsTemplateByIA] = useState(false);

  const onIsAPublishBulletinChange = ({ target: { value } }) => {
    const isIncomingValueTrue = value === 'true';
    setErrors(({ ifexcerpt, ...restOfProperties }) => ({ ...restOfProperties }));
    setTemplateTiny({
      ...templateTiny,
      ifexcerpt: isIncomingValueTrue,
      isAPublic: isIncomingValueTrue,
    });
  };

  useEffect(() => {
    if (type !== '') {
      (async function () {
        try {
          loader.show(true);
          await getTemplatesByType(type, setTemplates, expedientId);
          const hydre = (formattedPromotions) => {
            setAgreementTypes(formattedPromotions);
            setSelectedAgreementTypes(formattedPromotions);
          };

          await getAgreementTypes(setAgreementTypes, hydre);

          // if (judgesAndSecretaries && Object.keys(judgesAndSecretaries).length === 0) {
          //   setTemplateTiny({
          //     ...templateTiny,
          //     judgeName: '',
          //     agreementsSecretary: ''
          //   });
          // } else {
          //   setTemplateTiny({
          //     ...templateTiny,
          //     judgeName: judgesAndSecretaries.judge || '',
          //     agreementsSecretary: judgesAndSecretaries.secretary || ''
          //   });
          // }

          const hydratePromotions = (formattedPromotions) => {
            setPromotions(formattedPromotions);
          };
          if (type === 'agreement') {
            setSelectedPromotions([]);
            await getPromotionsWithoutAgreement(expedientId, hydratePromotions);
          }

          setHoliday(await holidayDates());
          if (type === 'notification') await getEmailsTemplates(expedientId, setEmailsOptions);
        } finally {
          loader.show(false);
          setIsDataLoaded(true);
        }
      })();
    }
  }, []);

  const onSelectRubroChange = async (selected) => {
    setSelectedAgreementTypes(selected);
    setErrors(({ alias, ...restOfProperties }) => ({ ...restOfProperties }));
    const agreementsFormatted = selected ? selected.map((p) => p.value) : [];
    const agreementsFormattedLabel = selected ? selected.map((p) => p.label) : [];
    setSelectedAlias(agreementsFormattedLabel.toString());
    setTemplateTiny({
      ...templateTiny,
      alias: agreementsFormattedLabel.toString(),
      headings: agreementsFormatted,
    });
  };

  const openModalTinyTemplate = (template) => {
    if (template) {
      setBackdrop(getLetterheadBackdrop(template));
      // Se fija al abrir, no segun el valor editado: asi el editor no
      // desaparece al vaciar el campo.
      setHasHeader(Boolean(template['has_header']));
      setHeaderContent(template['header'] || '');
      setSelectedPromotions([]);
      setErrors({});
      const promotionsFormatted = selectedPromotions ? selectedPromotions.map((p) => p.value) : [];
      const templateHeadings = template['headings'] || [];
      const selectedAgreements = agreementTypes.filter((agreementType) =>
        templateHeadings.includes(agreementType.value)
      );

      const agreementsFormatted = selectedAgreements.map((p) => p.value);
      const agreementsFormattedLabel = selectedAgreements.map((p) => p.label);

      setSelectedAgreementTypes(selectedAgreements);
      setSelectedAlias(agreementsFormattedLabel.toString());

      setTemplateTiny({
        content: template['content'],
        document_id: template['id'],
        name: template['name'],
        user_id: userId_03,
        expedient: expedientNumber.replace(/-/g, '/'),
        expedient_id: expedientId,
        type: type,
        comments: '',
        comment: '',
        // judgeName: judgesAndSecretaries.judge || '',
        // agreementsSecretary: judgesAndSecretaries.secretary || '',
        alias: isTemplateByIA
          ? template['name']
          : type !== 'agreement'
            ? template['name']
            : template['alias'] || '',
        answer_promotion: true,
        all_promotion: true,
        promotions_ids: promotionsFormatted.toString(),
        headings: type == 'agreement' ? agreementsFormatted : [],
        isAPublic: false,
      });
      setShowModalTiny(true);
    }
  };

  const handleEditorChange = (e) => {
    delete errors['content'];
    delete errors['html'];

    setTemplateTiny({
      ...templateTiny,
      content: e.content,
    });
  };

  // Telon de membrete del editor: se ve mientras se escribe, no se guarda.
  const [backdrop, setBackdrop] = useState({ backgroundUrl: '' });
  // Encabezado: mPDF lo repite en todas las hojas, por eso se edita aparte.
  const [headerContent, setHeaderContent] = useState('');
  const [hasHeader, setHasHeader] = useState(false);

  const [validateType, setStyle] = useState('cont');
  const [cssValidate, setCssValidate] = useState({});
  const isFieldShowing = getIsFieldShowingInFile(templateTiny.type);

  const tinyEditor = (
    <div style={{ margin: '0 auto', width: 'auto' }}>
      <div style={{ margin: '0 auto', width: '80%' }}>
        <Form>
          <Form.Group>
            <Form.Label>
              {templateTiny['type'] === 'agreement'
                ? '* Rubro'
                : templateTiny['type'] == 'writ'
                  ? 'Etiqueta'
                  : '* Nombre'}
            </Form.Label>
            {templateTiny['type'] === 'agreement' ? (
              <div id="validateSelect" className={validateType} style={cssValidate}>
                <Select
                  id="selectRubro"
                  defaultValue={selectedAgreementTypes}
                  onChange={onSelectRubroChange}
                  value={selectedAgreementTypes}
                  isClearable={false}
                  isMulti
                  options={agreementTypes}
                  placeholder="Selecciona rubros"
                  className="basic-multi-select"
                  classNamePrefix="select"
                  noOptionsMessage={
                    agreementTypes.length > 0
                      ? () => 'Sin más opciones disponibles'
                      : () => 'Sin opciones disponibles'
                  }
                  styles={stylesFormatted}
                />
              </div>
            ) : (
              <Form.Control
                onChange={(e) => {
                  delete errors['alias'];
                  setTemplateTiny({ ...templateTiny, alias: e.target.value });
                }}
                className={renderClassesToErrors(errors, 'alias')}
                placeholder="Agrega un nombre"
                value={templateTiny['alias']}
              />
            )}
            {renderErrorsList(errors, 'alias')}
          </Form.Group>
          <hr />

          {isFieldShowing && (
            <>
              <Form.Group>
                <Form.Label>Observaciones internas sobre el documento:</Form.Label>
                <Form.Control
                  onChange={(e) =>
                    setTemplateTiny({
                      ...templateTiny,
                      comments: e.target.value,
                    })
                  }
                  as="textarea"
                  rows="5"
                  aria-label="Observaciones"
                  className={renderClassesToErrors(errors, 'comments')}
                />
                <Form.Text>
                  Escribe aquí las observaciones para corrección del documento previo al firmado
                  electrónico del mismo.
                </Form.Text>
                {renderErrorsList(errors, 'comments')}
              </Form.Group>
              <hr />
            </>
          )}

          {isFieldShowing && (
            <>
              <Form.Group>
                <Form.Label>Comentarios sobre el resumen del documento:</Form.Label>
                <Form.Control
                  onChange={({ target: { value } }) =>
                    setTemplateTiny({ ...templateTiny, comment: value })
                  }
                  as="textarea"
                  rows="5"
                  aria-label="Comentarios"
                />
                <Form.Text>
                  Escribe aquí los comentarios que desees que se visualicen como resumen del
                  documento.
                </Form.Text>
              </Form.Group>
              <hr />
            </>
          )}

          {shouldAskIfIsAPublishBulletin && (
            <>
              <Form.Group>
                <Form.Label>* ¿Desea publicar en el boletín?</Form.Label>
                {renderErrorsList(errors, 'ifexcerpt')}
                <section>
                  <Form.Check
                    inline
                    label="Si"
                    name="publishBulletin"
                    type={'radio'}
                    id={'publish-bulletin'}
                    value={true}
                    onChange={onIsAPublishBulletinChange}
                  />
                  <Form.Check
                    inline
                    label="No"
                    name="publishBulletin"
                    type={'radio'}
                    id={'do-not-publish-bulletin'}
                    value={false}
                    onChange={onIsAPublishBulletinChange}
                  />
                </section>
              </Form.Group>
              {templateTiny.ifexcerpt && (
                <>
                  {(templateTiny['type'] === 'judgment' ||
                    templateTiny['type'] === 'agreement') && (
                    <BulletinFields
                      values={templateTiny}
                      //judgesAndSecretaries={judgesAndSecretaries}
                      onChange={setTemplateTiny}
                      errors={errors}
                      renderErrorsByInputName={renderErrorsList}
                      documentType={templateTiny['type']}
                    />
                  )}

                  <Form.Group>
                    <Form.Label>* Extracto para boletín:</Form.Label>
                    {renderErrorsList(errors, 'excerpt')}
                    <Form.Control
                      onChange={(e) => {
                        setErrors(({ excerpt, ...restOfProperties }) => ({
                          ...restOfProperties,
                        }));
                        setTemplateTiny({
                          ...templateTiny,
                          excerpt: e.target.value,
                        });
                      }}
                      as="textarea"
                      rows="5"
                      aria-label="Extracto para boletín"
                      className={renderClassesToErrors(errors, 'excerpt')}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>* Fecha de publicación a boletín:</Form.Label>
                    <DatePicker
                      renderCustomHeader={({
                        date,
                        changeYear,
                        changeMonth,
                        decreaseMonth,
                        increaseMonth,
                        prevMonthButtonDisabled,
                        nextMonthButtonDisabled,
                      }) =>
                        secondCustomHeaderDatePicker(
                          date,
                          changeYear,
                          changeMonth,
                          decreaseMonth,
                          increaseMonth,
                          prevMonthButtonDisabled,
                          nextMonthButtonDisabled
                        )
                      }
                      dateFormat="dd/MM/yyyy"
                      locale="es"
                      minDate={new Date()}
                      filterDate={
                        dataExpedient &&
                        dataExpedient.kind_judgment_id === 59 &&
                        dataExpedient.matter === 'Laboral'
                          ? undefined
                          : isWeekday
                      }
                      excludeDates={
                        dataExpedient &&
                        dataExpedient.kind_judgment_id === 59 &&
                        dataExpedient.matter === 'Laboral'
                          ? undefined
                          : holiday
                      }
                      customInput={<CustomInputDate ref={firstInputDatePicker} />}
                      selected={
                        templateTiny['publication_date']
                          ? moment(templateTiny['publication_date']).toDate()
                          : ''
                      }
                      onChange={(date) => {
                        setTemplateTiny({
                          ...templateTiny,
                          publication_date: date,
                        });
                        setDateIsAccepted(false);
                        setErrors({ ...errors, publication_date: [] });
                      }}
                    />
                    {templateTiny['publication_date'] && (
                      <>
                        <p className="text-xs">
                          Elegiste el día:{' '}
                          {moment(templateTiny['publication_date']).format('DD/MM/YYYY')}
                        </p>
                        {!dateIsAccepted && (
                          <div className="">
                            <p>¿Estás seguro de que deseas continuar?</p>
                            <span>
                              <button
                                className="btn btn-xs btn-success ml-2"
                                onClick={() => {
                                  setDateIsAccepted(true);
                                }}
                                onMouseDown={(e) => e.preventDefault()}
                              >
                                Aceptar
                              </button>
                            </span>
                            <span>
                              <button
                                className="btn btn-xs btn-danger ml-2"
                                onClick={() => {
                                  setTemplateTiny({ ...templateTiny, publication_date: '' });
                                  setDateIsAccepted(false);
                                }}
                                onMouseDown={(e) => e.preventDefault()}
                              >
                                Cancelar
                              </button>
                            </span>
                          </div>
                        )}
                      </>
                    )}
                    {renderErrorsList(errors, 'publication_date')}
                  </Form.Group>
                </>
              )}
              <hr />
            </>
          )}

          {type === 'agreement' ? (
            <Form.Group>
              <Form.Label>¿Deseas responder promociones?</Form.Label>
              <Form.Check
                type="checkbox"
                label={'Si'}
                checked={templateTiny['answer_promotion'] && promotions.length > 0 ? true : false}
                id={'si'}
                value={templateTiny['answer_promotion'] ? false : true}
                onChange={(e) => {
                  if (e.target.value === 'true') {
                    if (promotions.length === 0)
                      NotificationManager.error(
                        'No existen promociones disponibles para responder'
                      );
                    const promotionsFormatted = selectedPromotions
                      ? selectedPromotions.map((p) => p.value)
                      : [];
                    setTemplateTiny({
                      ...templateTiny,
                      answer_promotion: true,
                      promotions_ids: promotionsFormatted.toString(),
                    });
                  } else {
                    delete templateTiny['promotions_ids'];
                    setTemplateTiny({
                      ...templateTiny,
                      answer_promotion: false,
                    });
                  }
                }}
                className={renderClassesToErrors(errors, 'answer_promotion')}
              />
              {renderErrorsList(errors, 'answer_promotion')}
              <hr />
            </Form.Group>
          ) : (
            ''
          )}

          {templateTiny['answer_promotion'] === true && type === 'agreement' ? (
            <>
              <Form.Group>
                <Form.Label>Respuesta a promociones:</Form.Label>
                <Select
                  onChange={(selected) => {
                    setSelectedPromotions(selected);
                    const promotionsFormatted = selected ? selected.map((p) => p.value) : [];
                    setTemplateTiny({
                      ...templateTiny,
                      answer_promotion: true,
                      promotions_ids: promotionsFormatted.toString(),
                      all_promotion: promotions.length === promotionsFormatted.length,
                    });
                  }}
                  value={selectedPromotions}
                  isClearable={false}
                  isMulti
                  options={promotions}
                  placeholder="Selecciona las promociones de este acuerdo"
                  className="basic-multi-select"
                  classNamePrefix="select"
                  noOptionsMessage={
                    promotions.length > 0
                      ? () => 'Sin más opciones disponibles'
                      : () => 'Sin opciones disponibles'
                  }
                  styles={stylesFormatted}
                />
                {renderErrorsList(errors, 'promotions_ids')}
              </Form.Group>
              <hr />
            </>
          ) : (
            ''
          )}

          {
            <Form.Group>
              <Form.Label>* Documento:</Form.Label>
              {renderErrorsList(errors, 'content')}
            </Form.Group>
          }
        </Form>
      </div>
      <>
        {/* Fuera del contenedor flex: ahi dentro los editores salen en fila y
          su CSS global fuerza `min-height: 1000px !important`. */}
        {hasHeader && (
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <div style={{ width: '80%', marginBottom: '12px' }}>
              <Form.Label>Encabezado (se repite en todas las páginas)</Form.Label>
              {/* 300 px: la barra de herramientas ocupa dos filas (~110 px), asi
                  que por debajo de eso casi no queda area de escritura. */}
              <div style={{ height: '300px' }}>
                {/* Claves distintas: dos hermanos del mismo componente, uno
                    condicional, para que React no reutilice una instancia. */}
                <RichTextEditor
                  key="editor-encabezado"
                  value={headerContent}
                  onChange={(e) => setHeaderContent(e.content)}
                  height={300}
                />
              </div>
            </div>
          </div>
        )}
        {/* Fuera del contenedor flex: dentro quedaria al lado del editor. */}
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <div style={{ width: '80%' }}>
            <Form.Label>Cuerpo:</Form.Label>
          </div>
        </div>
        <div className={'container-preview-templates' + (errors['content'] ? '-error' : '')}>
          <RichTextEditor
            key="editor-cuerpo"
            value={templateTiny.content}
            onChange={handleEditorChange}
            imagesWithCorsErrorState={imagesWithCorsErrorState}
            contentStyle={buildLetterheadContentStyle(backdrop.backgroundUrl)}
          />
        </div>
      </>
    </div>
  );

  const onSaveTemplate = async () => {
    const saveTemplateResponse = await handleRequestSaveTemplate(templateTiny);
    if (!saveTemplateResponse) {
      return;
    }

    setShowModalTemplates(false);
    setShowModalTiny(false);
  };

  const handleRequestSaveTemplate = async () => {
    let aliasToValidate = templateTiny['alias'] || '';
    if (type === 'agreement') {
      aliasToValidate = selectedAlias || '';
    }
    const requiredFields = ['alias', 'content', 'user_id'];

    if (shouldAskIfIsAPublishBulletin && templateTiny.ifexcerpt === undefined) {
      requiredFields.push('ifexcerpt');
    }

    if (templateTiny.ifexcerpt) {
      requiredFields.push('excerpt');
      if (!templateTiny.publication_date) requiredFields.push('publication_date');
      if (templateTiny['type'] === 'judgment') {
        // if (!templateTiny.judgeName) requiredFields.push('judgeName');
        // if (!templateTiny.agreementsSecretary) requiredFields.push('agreementsSecretary');
        if (!templateTiny.sentenceDate) requiredFields.push('sentenceDate');
        // if(!templateTiny.crimes_id) requiredFields.push('crimes_id');
      }

      // Validar que la fecha de publicación no sea pasada (comparando en la zona horaria local del usuario)
      if (templateTiny.publication_date) {
        const pubDate = moment(templateTiny.publication_date).startOf('day');
        const today = moment().startOf('day');
        const isLaboralExpedient =
          dataExpedient &&
          dataExpedient.kind_judgment_id === 59 &&
          dataExpedient.matter === 'Laboral';
        if (pubDate.isBefore(today) && !isLaboralExpedient) {
          NotificationManager.error(
            'La fecha de publicación no puede ser una fecha pasada. Por favor seleccione una fecha válida.'
          );
          setErrors((prev) => ({
            ...prev,
            publication_date: ['La fecha de publicación no puede ser una fecha pasada.'],
          }));
          return;
        }
      }
    }

    const responseValidation = fieldsValidation(
      requiredFields,
      { ...templateTiny, alias: aliasToValidate },
      selectedAgreementTypes
    );

    if (Array.isArray(selectedAgreementTypes)) {
      if (selectedAgreementTypes.length == 0) {
        setStyle('is-invalid');
        setCssValidate({ borderStyle: 'solid', borderWidth: 'thin', borderRadius: '4px' });
      } else if (selectedAgreementTypes.length > 7) {
        setStyle('is-invalid');
        setCssValidate({ borderStyle: 'solid', borderWidth: 'thin', borderRadius: '4px' });
        NotificationManager.error('Por favor, rectifique el campo "Rubro"');
      } else {
        setStyle('');
        setCssValidate({});
      }
    } else {
      if (selectedAgreementTypes == null) {
        setStyle('is-invalid');
        setCssValidate({ borderStyle: 'solid', borderWidth: 'thin', borderRadius: '4px' });
      } else {
        setStyle('');
        setCssValidate({});
      }
    }

    if (typeof responseValidation === 'object') {
      NotificationManager.error('Los campos marcados en rojo son requeridos, revísalos');
      setErrors(responseValidation);
    } else {
      const templateTinyToSendValues = {
        ...templateTiny,
        header_content: headerContent,
        alias: aliasToValidate,
        ...(isTemplateByIA && iaTemplateId ? { draft_template_id: iaTemplateId } : {}),
      };
      if (typeof templateTinyToSendValues['alias'] === 'object') {
        templateTinyToSendValues['alias'] = templateTinyToSendValues['alias']['value'];
      }

      const { isAPublishBulletin, ...templateTinyToSend } = templateTiny;

      const templatePresaveResponse = await requestTemplatePresave(
        templateTinyToSendValues,
        setErrors,
        setReloadDataTemplates,
        reloadDataTemplates,
        setShowModalTiny,
        setShowModalTemplates
      );
      return templatePresaveResponse;
    }
  };

  const handleSaveTemplate = async ({ isACallFromAgreementWithoutPromotionModal } = {}) => {
    loader.show(true);
    const areThereTemplateImagesWithCorsError =
      await imagesWithCorsErrorState.getAreThereTemplateImagesWithCorsError(templateTiny.content);
    loader.show(false);

    if (areThereTemplateImagesWithCorsError) {
      return;
    }

    if (isACallFromAgreementWithoutPromotionModal) {
      handleRequestSaveTemplate(templateTiny);
      setShowModalConfirm(false);
      return;
    }

    const doAllPromotionsExist = Boolean(_.get(templateTiny, 'all_promotion'));
    if (doAllPromotionsExist) {
      onSaveTemplate();
      return;
    }

    setShowModalConfirm(true);
  };

  useEffect(() => {
    if (!isTemplateByIA || !isDataLoaded || hasAttemptedToOpenIAModal.current) return;

    hasAttemptedToOpenIAModal.current = true;

    (async function () {
      try {
        loader.show(true);
        const iaResult = await initIaTemplate(
          expedientId,
          userId_03,
          type,
          expedientNumber.replace(/-/g, '/')
        );

        if (!iaResult) {
          NotificationManager.error(
            'No fue posible generar el contenido con IA. Inténtalo nuevamente.'
          );
          setIsTemplateByIA(false);
          return;
        }

        setIaTemplateId(iaResult.template_id);

        if (iaResult.ia_down || !iaResult.ia_url) {
          NotificationManager.warning('El servicio de IA no está disponible en este momento.');
        } else {
          window.open(iaResult.ia_url, '_blank');
          NotificationManager.success(
            'Plantilla creada. Edita el contenido en el editor de IA y búscala en la lista para completar el guardado.'
          );
        }

        setIsTemplateByIA(false);
        setReloadDataTemplates(!reloadDataTemplates);
        setShowModalTemplates(false);
      } catch (e) {
        NotificationManager.error('Error al inicializar la plantilla con IA.');
        setIsTemplateByIA(false);
      } finally {
        loader.show(false);
      }
    })();
  }, [isTemplateByIA, isDataLoaded]);

  return (
    <div style={{ textAlign: 'center' }}>
      <div className="row">
        {templates.map((template, index) => (
          <div
            key={index}
            className="col-sm"
            style={stylesDiv3}
            onClick={() => openModalTinyTemplate(template)}
          >
            <IframeFunctional title={index}>
              <div style={stylesDiv} onClick={() => openModalTinyTemplate(template)}>
                <div
                  style={buildThumbnailStyle(stylesDiv2, template['letterhead_url'])}
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(template['html']),
                  }}
                />
              </div>
            </IframeFunctional>
            <br />
            <span>{template['name']}</span>
          </div>
        ))}
      </div>
      <ModalComponentPortal
        header={`${templateTiny['name']}:`}
        body={tinyEditor}
        footer={
          <>
            <Button
              variant="secondary"
              onClick={() => {
                setIsTemplateByIA(false);
                setShowModalTiny(false);
                if (isTemplateByIA) setShowModalTemplates(false);
              }}
            >
              Cerrar
            </Button>
            <Button
              variant="success"
              onClick={handleSaveTemplate}
              disabled={!dateIsAccepted && templateTiny.isAPublic}
            >
              <i className="fas fa-save" /> {'  '}
              Guardar
            </Button>
          </>
        }
        isModalShowing={showModalTiny}
        onHide={() => {
          setSelectedPromotions([]);
          setShowModalTiny(false);
          setIsTemplateByIA(false);
          if (isTemplateByIA) setShowModalTemplates(false);
        }}
      />

      <AgreementWithoutPromotionModal
        onCancelClick={() => setShowModalConfirm(false)}
        onAcceptClick={() =>
          handleSaveTemplate({ isACallFromAgreementWithoutPromotionModal: true })
        }
        onOutsideClick={() => {
          setSelectedPromotions([]);
          setShowModalConfirm(false);
        }}
        isModalShowing={showModalConfirm}
      />
    </div>
  );
};

export default PreviewTemplates;
